import { useMedia } from 'react-use'

import breakpoints from '@components/breakpoints.module.scss'

const useDetectMobile = () => useMedia(`(max-width: ${breakpoints.sm})`)

const useDetectTablet = () => useMedia(`(max-width: ${breakpoints.md})`)

export { useDetectMobile, useDetectTablet }
